const karnatakaCities = [
  {
    slug: "bangalore",
    city: "Bengaluru",
    title: "Sex Toys in Bangalore | Discreet Delivery in Bengaluru",
    description:
      "Buy sex toys in Bangalore with fast & discreet delivery. Explore premium couples wellness products in Bengaluru."
  },
  {
    slug: "mysuru",
    city: "Mysuru",
    title: "Sex Toys in Mysuru | Safe & Private Delivery",
    description:
      "Order sex toys in Mysuru online with 100% discreet packaging and fast delivery."
  },
  {
    slug: "mangalore",
    city: "Mangaluru",
    title: "Sex Toys in Mangalore | Discreet Online Store",
    description:
      "Buy sex toys in Mangalore with private & secure home delivery."
  },
  {
    slug: "hubli",
    city: "Hubli",
    title: "Sex Toys in Hubli | Couples Wellness Products",
    description:
      "Shop sex toys in Hubli with discreet delivery and trusted quality."
  },
  {
    slug: "belgaum",
    city: "Belgaum",
    title: "Sex Toys in Belgaum | Safe & Discreet Delivery",
    description:
      "Order sex toys in Belgaum online with privacy guaranteed."
  }
];

export default karnatakaCities;
